module.exports = __webpack_public_path__ + "static/media/icon_info.5823eb33.svg";